import script from "./ClubEventTournamentTypeList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTournamentTypeList.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTournamentTypeList.vue?vue&type=style&index=0&id=3430ec4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3430ec4c"]])

export default __exports__